import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`Route has 1L 1M extra for random battles, 2L 0M if HP Thief Hrodvitnir fight.`}</p>
    </blockquote>
    <SEO title="Octopath Traveler Ophilia Single Story" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Guide Summon Winds`}<br parentName="p"></br>{`
`}{`Purchase Quartz Rod`}</p>
    <h4 {...{
      "id": "guardian-1924hp"
    }}>{`Guardian 1924HP`}</h4>
    <p>{`Summon, Holy Light x4 when Broken`}</p>
    <p>{`Head to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch1"
    }}>{`Cyrus Ch.1`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`Light S`}</strong>{`, `}<strong parentName="p">{`Light M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Quartz Rod`}</strong>{` & equip to Cyrus`}</p>
    <p>{`Optionally pick `}<strong parentName="p">{`Light S`}</strong>{` in Study`}</p>
    <h4 {...{
      "id": "russell-3097hphp"
    }}>{`Russell 3097HP/?HP`}</h4>
    <p>{`Summon for Wind and Break Russell`}<br parentName="p"></br>{`
`}{`Use Fire Ball T1 and T2 for Break Icicle`}<br parentName="p"></br>{`
`}{`Use 1 Small Soulstone + Max Icy Wind for kill Icicle (need 1 winds)`}<br parentName="p"></br>{`
`}{`When Russell are broken use BPx4 Holy Light and BPx4 Fire Ball/Small Stone`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Luminiscence`}</li>
        <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      </ul>
    </Menu>
    <p>{`Go to Whistlewood, kill stuff till Cyrus has enough JP for EM`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job-1"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Blizzard`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Noblecourt`}</strong>{`. Scrutinize & Pick `}<strong parentName="p">{`Thunder L`}</strong>{` & `}<strong parentName="p">{`Curious Antique`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head towards `}<strong parentName="p">{`Grandport`}</strong>{`. Tag `}<strong parentName="p">{`Rippletide`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`North Cobbleston Gap`}</strong>{`: Pick `}<strong parentName="p">{`$1200`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Moonstruck Coast`}</strong>{`: S&Q, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Grandport Coast`}</strong>{`: Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Wind L`}</p>
    <p>{`Run to `}<strong parentName="p">{`Saintsbridge`}</strong>{`, start Chapter 2.`}</p>
    <h3 {...{
      "id": "chapter-2-start"
    }}>{`Chapter 2 Start`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Shadow M`}</strong>{`, `}<strong parentName="p">{`Shadow L`}</strong>{`. After cutscene by middle TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Bolderfall`}</strong>{`. 2nd screen reset via Hoarfrost Grotto.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`S&Q in Manor`}</p>
    <h4 {...{
      "id": "heathecote"
    }}>{`Heathecote`}</h4>
    <p>{`Thunder L, Ice M, Shadow M`}</p>
    <p>{`Steal `}<strong parentName="p">{`Nourishing S`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`. Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Forbidden Dagger`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "chapter-2-continued"
    }}>{`Chapter 2 Continued`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`More Items in Shop (30%)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Wind L`}</strong>{`, `}<strong parentName="p">{`Wind M`}</strong>{`.`}</p>
    <p>{`S&Q outside Murkwood, kill if you got the encounter before. Pick `}<strong parentName="p">{`$3500`}</strong>{`.`}<br parentName="p"></br>{`
`}{`In Murkwood kill encounter with L Stone (DO NOT USE SHADOW L IF THERION IS THROWING IT)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Forbidden Dagger`}</li>
      </ul>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive, HP Thief if enough JP`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir-34969hp-sword-spear-ice-lightning-light"
    }}>{`Hrodvitnir 34969HP (Sword, Spear, Ice, Lightning, Light)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`HP Thief let's you use a M instead of a L`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-no-hp-thief--hp-thief"
    }}>{`Turn 1 (No HP Thief / HP Thief)`}</h5>
    <blockquote>
      <p parentName="blockquote">{`Turn 1 Merchant 1/2 refers to T2 turn order`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Merchant 1: Spear / Spear x2`}</li>
      <li parentName="ul">{`Merchant 2: Spear`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Therion: Sword x2 / Sword`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x3`}</li>
      <li parentName="ul">{`Merchants: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHV x4`}</li>
      <li parentName="ul">{`Merchant 2: Collect x4 / Collect x2`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Dagger`}</strong>{` x2 / HP Thief x4`}</li>
      <li parentName="ul">{`Cyrus: L Stone / M Stone`}</li>
    </ul>
    <p>{`Buy 8 Empowering Bracelet`}</p>
    <h3 {...{
      "id": "chapter-3"
    }}>{`Chapter 3`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`$4500`}</strong>{`. Scrutinize `}<strong parentName="p">{`Wind L`}</strong>{`, pick `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Grandport`}</strong>{`. Purchase `}<strong parentName="p">{`2 Pom L`}</strong>{`. Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. Pick `}<strong parentName="p">{`$25000`}</strong>{`, `}<strong parentName="p">{`Dazzling Artwork`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`. Guide Flurry Guy. Steal `}<strong parentName="p">{`Peacekeeper's Garb`}</strong>{` & `}<strong parentName="p">{`Old Coin`}</strong>{` from guy with stand by shop.`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Scrutinize & Pick `}<strong parentName="p">{`Thunder L`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: 2 Bracelet`}</li>
        <li parentName="ul">{`Cyrus: 2 Bracelet, Peacekeeper Garb`}</li>
        <li parentName="ul">{`Tressa: 2 Bracelet`}</li>
        <li parentName="ul">{`Therion: 2 Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Healing Grape Bunch`}</li>
        <li parentName="ul">{`Nourishing S Therion`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "path-to-the-seaside-grotto"
    }}>{`Path to the Seaside Grotto`}</h3>
    <ul>
      <li parentName="ul">{`Azure Urchin: (1) 5611HP `}{`[Spear, Thunder, Light]`}</li>
      <li parentName="ul">{`Dark Curator: (3) 4790HP `}{`[Spear, Bow, Staff, Light]`}</li>
      <li parentName="ul">{`Flame Curator: (2) 4557HP `}{`[Spear, Bow, Staff, Ice]`}</li>
      <li parentName="ul">{`Scythe Crab: (3) 2484HP `}{`[Dagger, Axe, Wind]`}</li>
      <li parentName="ul">{`Mossy Tortoise: (4) 3808HP `}{`[Sword, Wind]`}</li>
    </ul>
    <h4 {...{
      "id": "battles"
    }}>{`Battles`}</h4>
    <ul>
      <li parentName="ul">{`1 Dark Curator 2 Flame Curator: go for Flurry, Blizzard.`}</li>
      <li parentName="ul">{`2 Dark Curator 1 Flame Curator: need a Flurry, can Blizzard to stall a bit. `}</li>
      <li parentName="ul">{`1 Azure Urchin 3 Scythe Crab: 3xHH800$ breaks crabs, Holy Light the Urchin. `}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Mossy Tortoise: 4xHH150, Holy Light the Urchin`}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Flame Curator 1 Scythe Crab: `}<ul parentName="li">
          <li parentName="ul">{`Ophilia Holy Light Azure Urchin, Cyrus Blizzard, Tressa Defend + 3HH800$`}</li>
          <li parentName="ul">{`If Therion before Tressa, can try to Dagger Scythe Crab to save a turn`}</li>
        </ul></li>
    </ul>
    <p>{`S&Q inside Seaside Grotto.`}</p>
    <h4 {...{
      "id": "mystery-man--shady-figure-2817232197hp"
    }}>{`Mystery Man & Shady Figure (28172/32197HP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Jank way to save L Stone. Use M + HP Thief T3, HP Thief x3 + Bandit/S Stone T4.`}<br parentName="p"></br>{`
`}{`Make sure you corrosive tankier guy x2 if you do this strat.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Cyrus: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: HHB / Spear if feeling risky`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: HHB x4`}</li>
      <li parentName="ul">{`Cyrus: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHM x4`}</li>
      <li parentName="ul">{`Ophilia: HHM x4`}</li>
      <li parentName="ul">{`Cyrus: L Stone`}</li>
      <li parentName="ul">{`Therion: Attack x2`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, head to `}<strong parentName="p">{`Whispermill`}</strong>{`.`}</p>
    <p>{`Break Plains Drake battle with Summon and Ophi/Tressa Spear Attacks. Then Flee.`}</p>
    <Menu mdxType="Menu">
      <p>{`Heal if needed.`}</p>
      <p>{`Remove `}<strong parentName="p">{`Forbidden Dagger`}</strong>{`.`}</p>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`.`}</p>
    <h3 {...{
      "id": "chapter-4"
    }}>{`Chapter 4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Healing Grape M (optional)`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Everything till $89000`}</li>
      </ul>
    </Menu>
    <p>{`S&Q in second screen. Pick `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <p>{`Break with HHM x4, kill with 1 L Stone + 2 M Stone`}</p>
    <h4 {...{
      "id": "mattias-97686hp"
    }}>{`Mattias 97686HP`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHM x2`}</li>
      <li parentName="ul">{`Merchant 2: Pom L Merchant 1`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Merchant 1: HHV x3 (Don't do 4 or 2!)`}</li>
      <li parentName="ul">{`Merchant 2: HHV x3`}</li>
      <li parentName="ul">{`Therion: Pom L Merchant 2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchants: HHV xMAX`}</li>
      <li parentName="ul">{`Cyrus & Therion: L Stone & M Stone`}</li>
    </ul>
    <p>{`2 Cutscene then GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      